/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componete Wrap
 */
export const Wrap = styled.div`
  position: relative;

  label {
    font-size: 12px;
    line-height: 14px;
    color: rgba(0, 0, 0, 0.56);
    display: block;
    margin-bottom: 8px;
  }

  .error {
    position: absolute;
    bottom: -18px;
    color: red;
    font-size: 10px;
  }

  .MuiInputBase-input {
    height: 40px;
    border: 0.5px solid rgba(0, 0, 0, 0.56);
    border-radius: 3px;
    /*margin-bottom: 30px;*/
    padding: 10px;
    box-sizing: border-box;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
  }

  .MuiInputAdornment-positionEnd {
    position: absolute;
    right: 16px;
    top: 20px;
    .MuiTypography-root {
      font-size: 18px;
    }
  }
`;
